export default "__VITE_ASSET__BvwiokCK__"